import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ProspectTable from "containers/pages/CANprospect/ProspectTable";
import AddProspectModal from "containers/pages/CANprospect/AddProspectModal";
import BulkImportModal from "containers/pages/CANprospect/BulkImportModal";

interface Prospect {
  id: number;
  companyName?: string;
  contactName?: string;
  phone?: string;
  email?: string;
  city?: string;
  industry?: string;
  assignedConsultant?: string;
  prospectStatus?: string;
}

function CANprospect() {
  const [modalOpen, setModalOpen] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [prospects, setProspects] = useState<Prospect[]>([]);

  const handleAddNew = () => {
    setModalOpen(true);
  };

  const handleBulkImport = () => {
    setBulkModalOpen(true);
  };

  const handleResetFilter = () => {
    window.location.href = window.location.pathname + "?page=0&search=";
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleBulkModalClose = () => {
    setBulkModalOpen(false);
  };

  const handleSaveProspect = (newProspect: Omit<Prospect, "id">) => {
    setProspects((prev) => [...prev, { id: Date.now(), ...newProspect }]);
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h4">Prospect List</Typography>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "90%",
          marginBottom: "1rem",
        }}
      >
        <Box style={{ display: "flex", gap: "0.5rem" }}>
          <Button variant="outlined" color="primary" onClick={handleAddNew}>
            + Add New
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleBulkImport}>
            + Bulk Import
          </Button>
        </Box>
        <Button variant="outlined" onClick={handleResetFilter}>
          reset filter
        </Button>
      </Box>
      <ProspectTable reload={!modalOpen && !bulkModalOpen} />
      <AddProspectModal
        open={modalOpen}
        onClose={handleModalClose}
        onSave={handleSaveProspect}
      />
      <BulkImportModal open={bulkModalOpen} onClose={handleBulkModalClose} />
    </Box>
  );
}

export default CANprospect;
